import React from 'react';
import { Box, Typography } from '@mui/material';
import ActivityStream from '../Components/Validation/ActivityStream';

export default function ValidationActivityLog() {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          Activity Log
        </Typography>
      </Box>
      <ActivityStream />
    </Box>
  );
}
